import * as React from "react";

export interface TooltipProps {
	tooltipTxt?: string; // for tooltip text
  tooltipList?: any;
}
export interface TooltipState {
	tooltipShow: boolean;
}

class Tooltip extends React.Component<TooltipProps, TooltipState> {
	constructor(props: TooltipProps) {
		//passing TooltipProps in props
		super(props);
		this.state = {
			tooltipShow: false // setting initially tooltipShow as false
		};
	}

  tooltipToggle = () =>
    //setting toggle state
    this.setState(currentState => ({ tooltipShow: !this.state.tooltipShow }));

  render() {
    return (
      <div className="tooltip_container">
        <i className="edel-icon-tooltip" onClick={this.tooltipToggle}></i>
        {/* if tooltipShow is true then show the tooltip content */}
        {this.state.tooltipShow && (
          <>
          <div className="tt_txt">
            {this.props.tooltipTxt &&<p>{this.props.tooltipTxt}</p>}
          </div>
          <div className="tt_Lst small-scroll">
            {this.props.tooltipList &&(
              <ul>
                {this.props.tooltipList.map(
                  (val: any) => {
                    return (
                      <li>
                        <i className="edel-icon-tick"></i>
                        <span>{val}</span>
                      </li>
                    );
                  }
                )}
              </ul>
            )}
          </div>
          </>
        )}
      </div>
    );
  }
}

export default Tooltip;
